<template>
  <div id="coin-app">
    <app-header />
    <router-view />
    <bottom-nav />
    <sec-password-modal />

    <transition name="toast">
      <div v-if="$root.toast.show" class="toast" :class="'toast--' + $root.toast.type" role="status">
        <span class="material-symbols-outlined">{{ $root.toast.type == 'success' ? 'check_circle' : 'error' }}</span>
        <span>{{ $root.toast.msg }}</span>
      </div>
    </transition>

    <div v-if="$root.isLoading" class="loading">
      <span class="spinner"></span>
    </div>
  </div>
</template>

<script>
import AppHeader from './components/appHeader.vue';
import BottomNav from './components/bottomNav.vue';
import SecPasswordModal from './components/secPasswordModal.vue';

export default {
  components: { AppHeader, BottomNav, SecPasswordModal },
};
</script>

<style lang="scss" scoped>
.toast {
  position: fixed;
  left: 50%;
  top: 72px;
  transform: translateX(-50%);
  z-index: 300;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: calc(100% - 32px);
  padding: 12px 16px;
  border-radius: var(--r-md);
  background: rgba(14, 18, 26, 0.95);
  border: 1px solid rgba(255, 229, 143, 0.35);
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.9);
  font-size: 14px;

  &--success .material-symbols-outlined { color: var(--mint); }
  &--danger .material-symbols-outlined,
  &--warning .material-symbols-outlined { color: var(--danger); }
}

.toast-enter-active,
.toast-leave-active { transition: opacity 0.2s, transform 0.2s; }
.toast-enter,
.toast-leave-to { opacity: 0; transform: translate(-50%, -8px); }

.loading {
  position: fixed;
  inset: 0;
  z-index: 250;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(11, 14, 20, 0.5);
}

.spinner {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid rgba(212, 175, 55, 0.2);
  border-top-color: var(--gold);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
